const token = import.meta.env.VITE_MIXPANEL_TOKEN;
const isEnabled = !!token;

/**
 * Initialize Mixpanel analytics
 * Uses dynamic import to prevent blocking app startup if mixpanel fails to load
 * Returns promise that resolves to true if initialized, false if failed/disabled
 */
export async function initMixpanel(): Promise<boolean> {
  if (!isEnabled) {
    console.log("[Mixpanel] Disabled - no token provided");
    return false;
  }

  try {
    // Dynamic import prevents blocking app if mixpanel fails to load (MIME type errors, CSP, etc.)
    const { default: mixpanel } = await import("mixpanel-browser");

    mixpanel.init(token, {
      autocapture: true,
      record_sessions_percent: 100,
    });

    // console.log("[Mixpanel] Initialized successfully");
    return true;
  } catch (error) {
    // Log error but don't block app startup
    console.warn(
      "[Mixpanel] Failed to initialize - app will continue without analytics:",
      error,
    );
    return false;
  }
}
